/**
 * Registry des Enquêtes & Témoignages Code 2 Roues.
 * Adaptés des 27 études de cas CCS ECSR officielles, mis en format magazine grand public.
 *
 * Format identique aux Magazines ETM (mêmes data shape + composant EtmIssuePage réutilisé).
 * Distinction visuelle/sémantique : badge "Enquête", URL /enquete/:slug.
 *
 * Série pilote — 8 numéros publiés.
 */

import { adosMobyletteEnquete } from './ados-mobylette';
import { livreursDeuxRouesEnquete } from './livreurs-deux-roues';
import { fatigueMotoEnquete } from './fatigue-moto';
import { alcoolMotoEnquete } from './alcool-moto';
import { permis125Enquete } from './permis-125-fausse-facilite';
import { surestimationEnquete } from './surestimation-motard';
import { risquePercuEnquete } from './risque-reel-vs-percu';
import { nuitMotoEnquete } from './nuit-moto';
import { vitesseJeunePermisEnquete } from './vitesse-jeune-permis';
import { cyclosCollegeEnquete } from './cyclos-college';
import { equipementMotardEnquete } from './equipement-motard';
import { choixPremiereMotoEnquete } from './choix-premiere-moto';
import { pneusMotoEnquete } from './pneus-moto';
import { circulationAmVilleEnquete } from './circulation-am-ville';
import { signalisationAmEnquete } from './signalisation-am';
import { risquesCycloEnquete } from './risques-cyclo-am';
import { groupeCycloEnquete } from './circulation-groupe-cyclo';
import { typesCyclosEnquete } from './types-cyclomoteurs';
import { constructionAccidentEnquete } from './construction-accident';
import { fataliteAccidentEnquete } from './fatalite-accident-moto';
import { groupeEvenementSportifEnquete } from './groupe-evenement-sportif';
import { transmissionMotoEnquete } from './transmission-moto';
import { achatOccasionMotoEnquete } from './achat-occasion-moto';
import { eclairageSignalisationEnquete } from './eclairage-signalisation-moto';
import { physiqueDeuxRouesEnquete } from './physique-deux-roues';
import { freinageDeuxRouesEnquete } from './freinage-deux-roues';
import { physiqueViragesEnquete } from './physique-virages-moto';
import { angleMort2RouesEnquete } from './angle-mort-2-roues';
import { trajectoireSecuriteEieEnquete } from './trajectoire-securite-virage-eie';
import { equipementMoto2026Enquete } from './equipement-moto-2026';
import { pressionPneusMotoEnquete } from './pression-pneus-moto';


// Liste publique pour vitrines / sections home / sitemap
export const ENQUETES_INDEX = [
  {
    slug: 'ados-mobylette',
    number: 1,
    title: 'Ces ados qui meurent à mobylette',
    short: 'Ados à mobylette',
    teaser: '80 morts/an chez les 14-17 ans à cyclo. Pourquoi, et que peuvent faire les parents ?',
    sourceCaseId: 26,
    accent: '#dc2626',
    status: 'published',
    issue: adosMobyletteEnquete,
  },
  {
    slug: 'livreurs-deux-roues',
    number: 2,
    title: 'Livreurs 2-roues : la course aux euros',
    short: 'Livreurs cyclo',
    teaser: 'Uber Eats, Deliveroo… Combien tu vaux à 4 € la course ?',
    sourceCaseId: 1,
    accent: '#ea580c',
    status: 'published',
    issue: livreursDeuxRouesEnquete,
  },
  {
    slug: 'fatigue-moto',
    number: 3,
    title: "Dormir, c'est rouler : la fatigue à moto",
    short: 'Fatigue',
    teaser: 'Pourquoi la micro-sieste de 12 secondes tue plus que l\'alcool sur 2 roues.',
    sourceCaseId: 22,
    accent: '#0891b2',
    status: 'published',
    issue: fatigueMotoEnquete,
  },
  {
    slug: 'alcool-moto',
    number: 4,
    title: '0,2 g/L : pourquoi à moto c\'est différent',
    short: 'Alcool & moto',
    teaser: 'Probatoire 0,2 g/L vs adulte 0,5 g/L — et le scoot, c\'est pire que la voiture.',
    sourceCaseId: 23,
    accent: '#7c3aed',
    status: 'published',
    issue: alcoolMotoEnquete,
  },
  {
    slug: 'permis-125-fausse-facilite',
    number: 5,
    title: 'Du B à la 125 : la fausse facilité',
    short: 'Passerelle 125',
    teaser: 'La formation 7h ne fait pas un motard. Ce que personne ne te dit avant.',
    sourceCaseId: 20,
    accent: '#1d4ed8',
    status: 'published',
    issue: permis125Enquete,
  },
  {
    slug: 'surestimation-motard',
    number: 6,
    title: 'L\'effet Dunning-Kruger à moto',
    short: 'Surestimation',
    teaser: 'Plus tu crois maîtriser, plus tu tombes. Le piège des motards expérimentés.',
    sourceCaseId: 13,
    accent: '#16a34a',
    status: 'published',
    issue: surestimationEnquete,
  },
  {
    slug: 'risque-reel-vs-percu',
    number: 7,
    title: 'Ce qui te fait peur n\'est pas ce qui te tue',
    short: 'Risque perçu',
    teaser: 'Tu crains les camions, c\'est ton voisin qui t\'envoie au tapis.',
    sourceCaseId: 17,
    accent: '#f59e0b',
    status: 'published',
    issue: risquePercuEnquete,
  },
  {
    slug: 'nuit-moto',
    number: 8,
    title: 'La nuit à moto : ce que tu ne vois pas',
    short: 'Conduite nocturne',
    teaser: '60 % des accidents mortels surviennent entre 21h et 7h. Pourquoi tu ne vois pas ce qui arrive.',
    sourceCaseId: 6,
    accent: '#0f172a',
    status: 'published',
    issue: nuitMotoEnquete,
  },
  {
    slug: 'vitesse-jeune-permis',
    number: 9,
    title: "À 90 km/h, tu freines en 70 m — pas en 30",
    short: 'Vitesse & jeune permis',
    teaser: "L'énergie de choc augmente au CARRÉ de la vitesse. 32 % des morts moto en sont la preuve.",
    sourceCaseId: 2,
    accent: '#b91c1c',
    status: 'published',
    issue: vitesseJeunePermisEnquete,
  },
  {
    slug: 'cyclos-college',
    number: 10,
    title: "Permis AM à 14 ans : ce qui t'attend vraiment",
    short: 'Cyclos & collège',
    teaser: '8h de formation, casque + gants CE, débridage = délit. Avant de signer, lis ça.',
    sourceCaseId: 3,
    accent: '#0ea5e9',
    status: 'published',
    issue: cyclosCollegeEnquete,
  },
  {
    slug: 'equipement-motard',
    number: 11,
    title: 'Casque, gants, blouson : ce que la chute fait à ton corps',
    short: 'Équipement motard',
    teaser: "60 % des lésions graves sont évitables. La physique de la chute, sans filtre.",
    sourceCaseId: 4,
    accent: '#ea580c',
    status: 'published',
    issue: equipementMotardEnquete,
  },
  {
    slug: 'choix-premiere-moto',
    number: 12,
    title: "La moto qui te plaît n'est pas celle qui te va",
    short: 'Première moto',
    teaser: "5 familles, 4 critères, 1 cadre légal A2. Avant le bon de commande, lis ça.",
    sourceCaseId: 5,
    accent: '#16a34a',
    status: 'published',
    issue: choixPremiereMotoEnquete,
  },
  {
    slug: 'pneus-moto',
    number: 13,
    title: "50 cm² de gomme : c'est tout ce qui te tient au sol",
    short: 'Pneus moto',
    teaser: '60 % des motards ne vérifient jamais leurs pneus. Comment lire un marquage, mesurer une pression.',
    sourceCaseId: 7,
    accent: '#0f172a',
    status: 'published',
    issue: pneusMotoEnquete,
  },
  {
    slug: 'circulation-am-ville',
    number: 14,
    title: '70 % des morts cyclo ont lieu en ville (oui, en VILLE)',
    short: 'Cyclo en ville',
    teaser: "Carrefours, refus de priorité, piétons, bus. Les 7 réflexes pour 14-16 ans.",
    sourceCaseId: 8,
    accent: '#7c3aed',
    status: 'published',
    issue: circulationAmVilleEnquete,
  },
  {
    slug: 'signalisation-am',
    number: 15,
    title: "Lire la route, c'est lire les panneaux",
    short: 'Signalisation AM',
    teaser: 'Les 4 catégories de panneaux et la signalisation au sol que ton AM doit maîtriser.',
    sourceCaseId: 9,
    accent: '#475569',
    status: 'published',
    issue: signalisationAmEnquete,
  },
  {
    slug: 'risques-cyclo-am',
    number: 16,
    title: 'Cyclo à 14 ans : les 4 trappes qui te tuent',
    short: 'Risques cyclo',
    teaser: 'Invisibilité, refus de priorité, perte de contrôle, pression des pairs — les pièges réels.',
    sourceCaseId: 10,
    accent: '#0891b2',
    status: 'published',
    issue: risquesCycloEnquete,
  },
  {
    slug: 'circulation-groupe-cyclo',
    number: 17,
    title: 'En meute à cyclo : pourquoi ton cerveau décroche',
    short: 'Cyclo en groupe',
    teaser: 'Les 4 effets du groupe sur ton cerveau et les 5 règles d\'or pour rouler ensemble.',
    sourceCaseId: 11,
    accent: '#db2777',
    status: 'published',
    issue: groupeCycloEnquete,
  },
  {
    slug: 'types-cyclomoteurs',
    number: 18,
    title: "50 cm³ et 1500 € : le bon choix de cyclo pour la rentrée",
    short: 'Choisir son cyclo',
    teaser: 'Les 4 familles de cyclomoteurs et les 4 critères pour bien acheter à 14 ans.',
    sourceCaseId: 12,
    accent: '#6366f1',
    status: 'published',
    issue: typesCyclosEnquete,
  },
  {
    slug: 'construction-accident',
    number: 19,
    title: 'Le « fromage suisse » : pourquoi un accident n\'est jamais 1 seule cause',
    short: 'Construction accident',
    teaser: 'Le modèle de Reason : 4 catégories de causes, 3 phases. Comprendre pour prévenir.',
    sourceCaseId: 14,
    accent: '#6b7280',
    status: 'published',
    issue: constructionAccidentEnquete,
  },
  {
    slug: 'fatalite-accident-moto',
    number: 20,
    title: 'Le « pas de chance » : pourquoi 90 % des accidents étaient évitables',
    short: 'Fatalité ?',
    teaser: 'La fatalité n\'existe pas — ONISR, modèle Reason, 4 leviers qui marchent vraiment.',
    sourceCaseId: 15,
    accent: '#0f172a',
    status: 'published',
    issue: fataliteAccidentEnquete,
  },
  {
    slug: 'groupe-evenement-sportif',
    number: 21,
    title: 'Bol d\'Or, MotoGP : pourquoi le retour de course tue',
    short: 'En meute après GP',
    teaser: '8 h à voir Quartararo à 280 km/h, puis tu rentres. 4 effets du groupe, 5 règles pour rentrer vivant.',
    sourceCaseId: 16,
    accent: '#dc2626',
    status: 'published',
    issue: groupeEvenementSportifEnquete,
  },
  {
    slug: 'transmission-moto',
    number: 22,
    title: 'Chaîne, cardan, courroie : choisis la transmission qui te ressemble',
    short: 'Chaîne / Cardan',
    teaser: '3 systèmes, 3 philosophies. Entretien, coûts, usages. Tout savoir avant de signer.',
    sourceCaseId: 18,
    accent: '#475569',
    status: 'published',
    issue: transmissionMotoEnquete,
  },
  {
    slug: 'achat-occasion-moto',
    number: 23,
    title: 'Acheter sa moto d\'occasion : la check-list anti-arnaque',
    short: 'Acheter d\'occasion',
    teaser: '12 points à vérifier en 20 min. Histovec, factures, kit chaîne, fourche, plaquettes.',
    sourceCaseId: 19,
    accent: '#15803d',
    status: 'published',
    issue: achatOccasionMotoEnquete,
  },
  {
    slug: 'eclairage-signalisation-moto',
    number: 24,
    title: 'Éclairage moto : ce que dit vraiment le code (et ce que les forces de l\'ordre contrôlent)',
    short: 'Éclairage légal',
    teaser: 'R313-3 à R313-7. LED non homologuées, plaque, brouillard arrière : 135 € chacun.',
    sourceCaseId: 21,
    accent: '#ca8a04',
    status: 'published',
    issue: eclairageSignalisationEnquete,
  },
  {
    slug: 'physique-deux-roues',
    number: 25,
    title: 'Pourquoi la moto ne tombe pas : 4 lois physiques qui te sauvent (ou pas)',
    short: 'Physique 2 roues',
    teaser: 'Effet gyroscopique, contrebraquage, transfert de masse, force centrifuge.',
    sourceCaseId: 24,
    accent: '#0d9488',
    status: 'published',
    issue: physiqueDeuxRouesEnquete,
  },
  {
    slug: 'freinage-deux-roues',
    number: 26,
    title: 'Frein avant ou arrière ? Le mythe qui te tue (ou te sauve)',
    short: 'Freinage moto',
    teaser: 'Avant = 70 %, arrière = 30 %. ABS depuis 2015. Distances 50/90/130 km/h.',
    sourceCaseId: 25,
    accent: '#1e40af',
    status: 'published',
    issue: freinageDeuxRouesEnquete,
  },
  {
    slug: 'physique-virages-moto',
    number: 27,
    title: 'Le virage en moto : pourquoi tu te penches (et pourquoi tu peux tomber)',
    short: 'Physique du virage',
    teaser: '40 % des accidents mortels = perte de contrôle en virage. Centrifuge, adhérence, trajectoire.',
    sourceCaseId: 27,
    accent: '#9333ea',
    status: 'published',
    issue: physiqueViragesEnquete,
  },
  {
    slug: 'angle-mort-2-roues',
    number: 28,
    title: "L'angle mort à moto : la zone qui tue (et personne n'en parle assez)",
    short: 'Angle mort',
    teaser: "38 % des accidents corporels en agglo impliquent un 2-roues. Cause n°1 : l'angle mort. 5 réflexes qui sauvent.",
    sourceCaseId: null,
    accent: '#dc2626',
    status: 'published',
    issue: angleMort2RouesEnquete,
  },
  {
    slug: 'trajectoire-securite-virage-eie',
    number: 29,
    title: 'E-I-E : la règle de 3 lettres qui te garde en vie en virage',
    short: 'Trajectoire E-I-E',
    teaser: 'Extérieur — Intérieur — Extérieur. 50 ans de pédagogie moto et la raison pour laquelle 40 % se tuent en virage.',
    sourceCaseId: null,
    accent: '#0891b2',
    status: 'published',
    issue: trajectoireSecuriteEieEnquete,
  },
  {
    slug: 'equipement-moto-2026',
    number: 30,
    title: 'Équipement moto 2026 : casque, gants, blouson — ce qui devient obligatoire (et ce qui change)',
    short: 'Équipement 2026',
    teaser: 'ECE 22.06, gants CE EN 13594, gilet jaune, dorsale. Ce qui est obligatoire, ce qui te coûte 135 €.',
    sourceCaseId: null,
    accent: '#f59e0b',
    status: 'published',
    issue: equipementMoto2026Enquete,
  },
  {
    slug: 'pression-pneus-moto',
    number: 31,
    title: "Pression pneus moto : 0,3 bar de trop ou de moins, tu changes de moto",
    short: 'Pression des pneus',
    teaser: '60 % des motards ne vérifient JAMAIS leurs pneus. Pourtant 0,3 bar change tout : trajectoire, freinage, éclatement.',
    sourceCaseId: null,
    accent: '#16a34a',
    status: 'published',
    issue: pressionPneusMotoEnquete,
  },
];

// Helper resolver — retourne le full issue object si publié
export function getEnqueteBySlug(slug) {
  const entry = ENQUETES_INDEX.find((e) => e.slug === slug && e.status === 'published');
  return entry?.issue || null;
}

// Helper pour la home : numéros publiés uniquement
export function getPublishedEnquetes() {
  return ENQUETES_INDEX.filter((e) => e.status === 'published');
}

export default ENQUETES_INDEX;
